import { faCog } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Grid, Tooltip } from '@mui/material'
import { makeStyles } from '@mui/styles'
import firebase from 'firebase/app'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import AgencyMenu from '../../../Components/AgencyMenu'
import Headline from '../../../Components/Headline'
import Loader from '../../../Components/Loader'
import { systemColors } from '../../../globalVariables'
import LastAgencyApplicants from './Modules/lastAgencyApplicants'
import LastOnlineApplicants from './Modules/lastOnlineApplicants'
import LastViewedCompanies from './Modules/lastViewedCompanies'
import LastViewedProfiles from './Modules/lastViewedProfiles'
import TaggedProfiles from './Modules/taggedProfiles'

const db = firebase.firestore()

const useStyles = makeStyles({
  settingsIcon: {
    width: 'fit-content',
    float: 'right',
    color: systemColors.grey,
    cursor: 'pointer',
    fontSize: 20,
    marginRight: 30,
    '&:hover': {
      color: systemColors.lighGrey
    }
  }
})

const DashboardCrew = ({ userUID, agencyData, refreshDataRedux }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const history = useHistory()

  // Change document title
  document.title = `${t('dashboard')} - Seanor`

  const [loadingData, setLoadingData] = useState(true)
  const [userRole, setUserRole] = useState('')
  const [settings, setSettings] = useState({})
  const [lastViewedCompanies, setLastViewedCompanies] = useState([])
  const [lastViewedProfiles, setLastViewedProfiles] = useState([])
  const [taggedProfiles, setTaggedProfiles] = useState([])

  useEffect(() => {
    let shouldUpdate = true

    ;(() => {
      db.collection('users')
        .doc(userUID)
        .get()
        .then((response) => {
          let data = JSON.stringify(response.data())
          data = JSON.parse(data)

          if (shouldUpdate) {
            setUserRole(data.data.userRole)
            if (data.data.settings !== undefined) {
              setSettings(data.data.settings)
            }
            if (data.data.lastViewedCompaniesCREW !== undefined) {
              setLastViewedCompanies(data.data.lastViewedCompaniesCREW)
            }
            if (data.data.lastViewedProfilesCREW !== undefined) {
              setLastViewedProfiles(data.data.lastViewedProfilesCREW)
            }
            if (data.data.taggedProfilesCREW !== undefined) {
              setTaggedProfiles(data.data.taggedProfilesCREW)
            }
            setLoadingData(false)
          }
        })
        .catch((error) => {
          console.log("Can't get users data", error)
          setLoadingData(false)
        })
    })()

    return () => {
      shouldUpdate = false
    }
  }, [refreshDataRedux, userUID])

  if (loadingData) {
    return <Loader />
  }

  return (
    <div id='dashboard'>
      <AgencyMenu type='crew' />

      <Headline />

      {/* Settings icon */}
      <div style={{ marginTop: 20 }}>
        <Tooltip title={t('dashboardSettings')} placement='top'>
          <div
            className={classes.settingsIcon}
            onClick={() =>
              history.push(`/${agencyData.id}/settings/crew-dashboard-settings`)
            }
          >
            <FontAwesomeIcon icon={faCog} />
          </div>
        </Tooltip>
      </div>

      {/* Dashboard items */}
      <div style={{ marginTop: 60 }}>
        <Grid
          container
          spacing={3}
          direction='row'
          justifyContent='center'
          alignItems='stretch'
        >
          {/* Last visited companies */}
          {userRole === 'agency_admin' ||
          userRole === 'super_admin' ||
          settings.adminPermissions.dashboard.allowLastViewedCompaniesCREW ===
            true ? (
            settings.userSettings !== undefined &&
            settings.userSettings.dashboard.allowLastViewedCompaniesCREW ===
              true ? (
              <Grid item>
                <LastViewedCompanies
                  companiesList={lastViewedCompanies}
                  agencyData={agencyData}
                  userUid={userUID}
                />
              </Grid>
            ) : null
          ) : null}

          {/* Last visited employees */}
          {userRole === 'agency_admin' ||
          userRole === 'super_admin' ||
          settings.adminPermissions.dashboard.allowLastViewedProfilesCREW ===
            true ? (
            settings.userSettings !== undefined &&
            settings.userSettings.dashboard.allowLastViewedProfilesCREW ===
              true ? (
              <Grid item>
                <LastViewedProfiles
                  profilesList={lastViewedProfiles}
                  agencyData={agencyData}
                  userUid={userUID}
                />
              </Grid>
            ) : null
          ) : null}

          {/* Tagged employees */}
          {settings.userSettings !== undefined &&
          settings.userSettings.dashboard.allowTaggedProfilesCREW === true ? (
            <Grid item>
              <TaggedProfiles
                taggedProfiles={taggedProfiles}
                agencyData={agencyData}
                userUid={userUID}
              />
            </Grid>
          ) : null}

          {/* Last agency applicants */}
          {settings.userSettings !== undefined &&
          settings.userSettings.dashboard.allowLastAgencyApplicantsCREW ===
            true ? (
            <Grid item>
              <LastAgencyApplicants agencyData={agencyData} userUid={userUID} />
            </Grid>
          ) : null}

          {/* Last online applicants  */}
          {settings.userSettings !== undefined &&
          settings.userSettings.dashboard.allowLastOnlineApplicantsCREW ===
            true ? (
            <Grid item>
              <LastOnlineApplicants agencyData={agencyData} userUid={userUID} />
            </Grid>
          ) : null}
        </Grid>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  agencyData: state.agencyDataRed.obj,
  refreshDataRedux: state.refreshDataRed.bool
})

export default connect(mapStateToProps)(DashboardCrew)
